import { motion } from 'framer-motion'
import { forwardRef } from 'react'

import { cn } from 'shared/utils'

export interface IButton extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  disabled?: boolean
  iconLeading?: JSX.Element | null
  iconTrailing?: JSX.Element | null
  onClick?: any
}

export const Button = forwardRef<HTMLButtonElement, IButton>(
  ({ text, onClick, disabled = false, iconLeading, iconTrailing, className }, ref) => {
    return (
      <motion.button
        whileTap={{ scale: 0.9 }}
        transition={{ type: 'spring', duration: 0.3 }}
        whileHover={{ scale: 1.08 }}
        className={cn(
          '*:not(:last-child) flex w-fit cursor-pointer select-none flex-row items-center justify-center gap-2 rounded-2xl px-4 py-1.5 font-medium text-white disabled:opacity-30 lg:py-2.5',
          className
        )}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
      >
        {iconLeading}
        {text && <span className="text-base lg:text-lg">{text}</span>}
        {iconTrailing}
      </motion.button>
    )
  }
)

Button.displayName = 'Button'
